import AdminPublishBar from "./AdminPublishBar";

export default function PresskitEditor({ content, longBioDraft, saving, dirty, onChange, onDiscard, onLongBioChange, onSubmit }) {
  return (
    <form className="admin-editor" onSubmit={onSubmit}>
      <div className="admin-editor-heading">
        <div>
          <p className="admin-kicker">Page content</p>
          <h2>Press Kit copy</h2>
          <p>Changes remain private until you publish them.</p>
        </div>
        <a href="/presskit" target="_blank" rel="noopener noreferrer">View page</a>
      </div>
      <fieldset className="admin-form-section">
        <legend>Page introduction</legend>
        <label>Kicker<input value={content.kicker} onChange={(event) => onChange("kicker", event.target.value)} required /></label>
        <label>Page title<input value={content.title} onChange={(event) => onChange("title", event.target.value)} required /></label>
        <label>Introduction<textarea rows="4" value={content.intro} onChange={(event) => onChange("intro", event.target.value)} required /></label>
      </fieldset>
      <fieldset className="admin-form-section">
        <legend>Biographies</legend>
        <label>Short bio<textarea rows="10" value={content.shortBio} onChange={(event) => onChange("shortBio", event.target.value)} required /></label>
        <label>Long bio paragraphs <small>Separate paragraphs with a blank line.</small><textarea rows="22" value={longBioDraft} onChange={(event) => onLongBioChange(event.target.value)} required /></label>
      </fieldset>
      <AdminPublishBar dirty={dirty} saving={saving} label="Publish Press Kit" onDiscard={onDiscard} />
    </form>
  );
}
